module.exports = __webpack_public_path__ + "static/intro_mission_girl_mobile-2f0d409cf704557a0f11125d57a977d7.svg";